import isNumber from 'lodash/isNumber';

/**
 * @param   { Number, String} value a Number or a String to be transformed
 * @param   { Number } decimalPlaces how many decimals you would like to place
 * @returns { String } a string rounded by given decimal
 */
export function toFixedDecimalPoint(value: number | string = '', decimalPlaces = 0): string {
    if (value === '') return '';

    let valFloat = parseFloat(value.toString().replace(/,/g, ''));
    valFloat = Number.isNaN(valFloat) ? 0 : valFloat;

    return valFloat.toFixed(decimalPlaces);
}

/**
 * @param   { Number, String } value a Number or a String to be transformed
 * @param   { Number } decimalPlace how many decimals you would like to place
 * @returns { String } a string with decimal or not
 */
export function formatMinDecimalPlace(value: string | number, decimalPlace = 0): string {
    if (value === null || value === undefined || value === '') {
        if (!__ENV_TEST__) {
            console.error('invalid value:', value);
        }
        return '';
    }

    if (!isNumber(decimalPlace)) {
        if (!__ENV_TEST__) {
            console.error('invalid decimalPlace:', decimalPlace);
        }
        decimalPlace = 0;
    }

    const numericValue = isNumber(value) ? value : Number.parseFloat(value);
    const currentDecimalPlaceLength = String(numericValue).split('.')[1]?.length || 0;
    const maxDecimalPlace = Math.max(currentDecimalPlaceLength, decimalPlace);

    return numericValue.toFixed(maxDecimalPlace);
}
